import { getStringFromObject } from '../constants/lodashUtils';

export const countCostAttributionChoices = (line) => {
    const hasCostAccount = Boolean(getStringFromObject('costCenter.key', line));
    const hasDistributionPlan = Boolean(getStringFromObject('distributionPlan.key', line));
    const isSkip = Boolean(line.skipCostAttribution);
    return (hasCostAccount ? 1 : 0) + (hasDistributionPlan ? 1 : 0) + (isSkip ? 1 : 0);
};

export const validateExactlyOneCostAttribution = (line, lineLabel) => {
    const choiceCount = countCostAttributionChoices(line);
    if (choiceCount === 0) {
        return `${lineLabel}: choose exactly one of cost account, distribution plan, or skip cost attribution.`;
    }
    if (choiceCount > 1) {
        return `${lineLabel}: choose only one of cost account, distribution plan, or skip cost attribution.`;
    }
    return null;
};

export default validateExactlyOneCostAttribution;
